import type {
	SmartPrompt,
	BlankObjectContentType,
	ChatPromptInputRef,
} from '@atlassian/conversation-assistant-blank-object-experience/types';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const CreateWithRovoExperience: LoadableType<{
	cloudId: string;
	contentId: string;
	orgId?: string;
	editorApi?: {
		aiExperience?: {
			actions: {
				openAIModal: (config: Record<string, unknown>) => void;
			};
		};
	};
	onPromptMouseEnter?: (prompt: SmartPrompt) => void;
	onPromptMouseLeave?: () => void;
	onPromptClick?: (prompt: SmartPrompt) => void;
	onPromptSubmit?: () => void;
	onDismiss?: () => void;
	onInputEmpty?: () => void;
	onInputContentChange?: (hasContent: boolean) => void;
	smartPromptsPosition?: 'above' | 'below';
	placement?: 'top' | 'bottom';
	contentType?: BlankObjectContentType;
	variant?: 'variant1' | 'variant2' | 'variant3';
	isPublishedPage?: boolean;
	promptInputRef?: React.Ref<ChatPromptInputRef>;
	initialHasInputContent?: boolean;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CreateWithRovoExperience" */ '../src/CreateWithRovoExperience.tsx'
			)
		).CreateWithRovoExperience,
});
